import './App.css'

import TravelGuide from './components/TravelGuide'

const App = () => <TravelGuide />

export default App
